import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});




export const getSnapToken = async (idProduk) => {
  try {
    // Menggunakan axios.post dengan body dan config terpisah
    const response = await axios.post(
      `${BASE_URL_BE}/payment/snap-token`, 
      { 
        // --- 1. BODY REQUEST: Kirim id_produk sebagai objek JSON ---
        id_produk: idProduk 
      },
      {
        // --- 2. CONFIG: Pindahkan headers ke objek konfigurasi ketiga ---
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'application/json' // Ubah Content-Type menjadi JSON
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating snap token:", error.response?.data || error.message);
    throw error;
  }
};


